<template>
  <div class="flex-col org-main">
    <div class="div-top">
      <i class="iconfont iconCommunity"
        style="font-size: 0.875rem; color: #d04a02"></i>
      <van-dropdown-menu>
        <van-dropdown-item v-model="order"
          :options="orderOptions"
          @change="changeOrder" />
      </van-dropdown-menu>

      <div id="contractor-company-list-filter"
        class="filter"
        @click="showSearch">
        <span>{{ $t("common.filter") }} </span>
        <i class="iconfont iconfilter-outline"></i>
      </div>
      <van-popup v-model="showSearchPanel"
        position="right"
        :style="{ height: '100%', width: '80%' }">
        <search-panel :type="searchPanelType"
          @search="searchByPanel"></search-panel>
      </van-popup>
    </div>
    <div class="cont-list">
      <van-list v-if="showFilter"
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad">
        <contractor-item-company v-for="item in list"
          v-bind:key="item.id"
          :data="item"
          :show-chk="isEdit"
          :show-prefer="showPrefer"
          @cancel="cancelMark"
          :disable-swipe="disableSwipe"></contractor-item-company>
      </van-list>
      <van-list v-if="!showFilter"
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad">
        <contractor-item-company v-for="item in list"
          v-bind:key="item.historyId"
          :data="item"
          :show-chk="isEdit"
          @cancel="cancelMark"
          :disable-swipe="disableSwipe"></contractor-item-company>
      </van-list>
    </div>
  </div>
</template>

<script>
import ContractorItemCompany from "./ContractorItemCompany";
import SearchPanel from "@components/common/SearchPanel";
import common from "@common/common";
import webService from "@network/webService";
export default {
  name: "",
  data () {
    return {
      disableSwipe: true,
      showPrefer: true,
      list: [],
      loading: false,
      finished: false,
      currentPage: 0,
      order: 3,
      orderOptions: [
        {
          text: "按查看时间排序",
          value: 3,
        },
        // {
        //     text: "按职务排序",
        //     value: 1,   
        // },
      ],
      showSearchPanel: false,
      searchPanelType: common.searchTypeEnum.contractor,
      oldSearchModel: {
        Search: "",
        SearchType: common.relationshipSearchTypeEnum.PEContact,
        ResponsibilityIds: [],
        TitleIds: [],
        RelationDeepthIds: [],
      },
      showFilter: false,
    };
  },
  components: {
    ContractorItemCompany,
    SearchPanel,
  },
  props: {
    pageType: {
      type: Number,
      default: 0,
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
  },
  mounted () {
    this.showFilter =
      this.pageType != common.searchTypeEnum.contractorHistory;
    this.disableSwipe =
      this.pageType != common.searchTypeEnum.contractorCompanyCollect;

    this.showPrefer =
      this.pageType != common.searchTypeEnum.contractorCompanyCollect;

    if (this.pageType == common.searchTypeEnum.contractorHistory) {
      this.order = 3;
    }
    // this.onLoad();
  },
  created () {
    // this.currentPage = 0;
    // this.list = [];
    // this.onLoad();
  },
  methods: {
    changeOrder (val) {
      console.log("order", this.order);
      this.currentPage = 0;
      this.list = [];
      this.requestPageData();
    },
    onLoad () {
      if (this.currentPage == 0) {
        this.list = [];
      }
      this.requestPageData();
    },
    showSearch () {
      this.showSearchPanel = true;
    },
    searchByPanel (searchParams) {
      if (searchParams.hasFilter) {
        document.getElementById('contractor-company-list-filter').classList.add('has-filter');
      } else {
        document.getElementById('contractor-company-list-filter').classList.remove('has-filter');
      }
      this.currentPage = 0;
      this.list = [];
      if (this.searchPanelType == common.searchTypeEnum.contractor) {
        this.oldSearchModel.SearchType =
          common.relationshipSearchTypeEnum.PEContact;
        // this.oldSearchModel.ResponsibilityIds =
        //     searchParams.ResponsibilityIds;
        this.oldSearchModel.TitleIds = searchParams.TitleIds;
        this.oldSearchModel.RelationDeepthIds =
          searchParams.RelationDeepthIds;
      }
      this.showSearchPanel = false;
      console.log(searchParams);
      this.requestPageData();
    },
    getData (searchModel) {
      this.loading = true;
      this.currentPage = 0;
      this.list = [];
      if (!searchModel) {
        searchModel = {
          PageSize: 100,
          Page: 0,
          SearchType: common.relationshipSearchTypeEnum.PEContact,
        };
      } else if (
        this.searchPanelType == common.searchTypeEnum.contractor
      ) {
        this.oldSearchModel = searchModel;
      }
      //web 数据请求
      this.requestPageData(true);
    },
    requestPageData (isFirst) {
      let searchModel = {
        PageSize: 16,
        Page: this.currentPage,
        SearchType: this.oldSearchModel.SearchType,
        Search: this.oldSearchModel.Search,
        // ResponsibilityIds: this.oldSearchModel.ResponsibilityIds,
        Positions: this.oldSearchModel.TitleIds,
        RelationDeepthIds: this.oldSearchModel.RelationDeepthIds,
        FavoriteType: common.favoriteTypeEnum.CompanyContact,
        OrderType: this.order,
      };
      console.log(this.pageType)
      if (this.pageType == common.searchTypeEnum.contractorCompanyCollect) {
        webService.getFavoriteRelationships(searchModel).then((res) => {
          if (isFirst) {
            this.currentPage = 0;
            this.list = [];
          }
          common.procssData_collect(this, res.data);
          this.loading = false;
        });
      } else if (
        this.pageType == common.searchTypeEnum.contractorCompanyHistory
      ) {
        webService.SearchMemberHisList(searchModel).then((res) => {
          if (isFirst) {
            this.currentPage = 0;
            this.list = [];
          }
          common.procssData(this, res.data);
          this.loading = false;
        });
      } else {
        webService.searchContractListWithCompany(searchModel).then((res) => {
          if (isFirst) {
            this.currentPage = 0;
            this.list = [];
          }
          common.procssData(this, res.data);
          this.loading = false;
        });
      }
    },
    selectAll () {
      this.list.forEach((element) => {
        element.checked = true;
      });
    },
    cancelSelected () {
      this.list.forEach((element) => {
        element.checked = false;
      });
    },
    deleteItem () {
      common.batchDeleteMarked(this);
    },
    cancelMark (id) {
      common.cancelMark(this, id);
    },
    changeSearchValue (value) {
      this.oldSearchModel.Search = value;
    }
  },
};
</script>

<style lang='less' scoped>
.org-main {
  height: 99%;
  display: flex;
  flex-direction: column;
  border-top: 1px solid #dedede;
}
.div-top {
  display: flex;
  align-items: center;
  height: 2.875rem;
  padding: 0.375rem 0.625rem;
  /deep/ .van-dropdown-menu__bar {
    box-shadow: none;
  }
  .org-name {
    flex: 2;
    font-size: 14px;
    font-weight: bolder;
    color: #464646;
    margin-left: 0.375rem;
  }
  .filter {
    text-align: right;
    flex: 1;
    span {
      font-size: 0.875rem;
    }
    img {
      width: 1.25rem;
      vertical-align: middle;
    }
  }
}
.cont-list {
  overflow: auto;
  flex: 1;
  height: 100%;
}
// /deep/ .van-dropdown-menu__bar{
//   height: ;
// }
</style>


// WEBPACK FOOTER //
// src/components/content/contractor/ContractorHistory.vue